import { render, staticRenderFns } from "./NewsDetail1.vue?vue&type=template&id=30d96b56&scoped=true"
var script = {}
import style0 from "./NewsDetail1.vue?vue&type=style&index=0&id=30d96b56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30d96b56",
  null
  
)

export default component.exports